export default "__VITE_ASSET__920f33ba__"